import LoadingButton from '@mui/lab/LoadingButton';
import { Button, styled } from '@mui/material';
import { Colors, ColorsV2 } from '../../../constants/color';

const CustomisedButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: Colors.secondary,
  height: '58px',
  borderRadius: '8px',
  justifyContent: 'flex-start',
  paddingLeft: '40px',
  '&:hover': {
    backgroundColor: Colors.secondary,
  },
});

const CustomisedIconButton = styled(Button)({
  height: '2.3em',
  borderRadius: '5px',
  backgroundColor: 'transparent',
  border: '1px solid white',
  color: 'white',
  fontSize: '0.7em',
  textTransform: 'none',
  '& .MuiButton-startIcon': {
    marginRight: '4px',
  },
  '&:hover': {
    backgroundColor: ColorsV2.acent,
    border: '1px solid white',
    color: 'white',
  },
  '&:disabled': { background: `${Colors.lightText} !important`, color: 'white' },
});

const CustomisedLoadingIconButton = styled(LoadingButton)({
  height: '2.3em',
  borderRadius: '5px',
  backgroundColor: 'transparent',
  border: '1px solid white',
  color: 'white',
  fontSize: '0.7em',
  textTransform: 'none',
  '& .MuiButton-startIcon': {
    marginRight: '4px',
  },
  '&:hover': {
    backgroundColor: ColorsV2.acent,
    border: '1px solid white',
    color: 'white',
  },
  '&:disabled': { background: `${Colors.lightText} !important`, color: 'white' },
});

const CustomisedSaveButton = styled(Button)({
  height: '2.3em',
  boxSizing: 'border-box',
  borderRadius: '5px',
  backgroundColor: 'transparent !important',
  background: 'transparent',
  textTransform: 'none',
  color: 'white',
  fontSize: '0.8em',
  border: `1px solid ${ColorsV2.white}`,
  '&:hover': {
    backgroundColor: `transparent !important`,
  },
  '&:disabled': { background: `${Colors.lightText} !important`, color: 'white' },
});
const CustomisedUploadButton = styled(Button)({
  backgroundColor: 'white',
  color: Colors.pageHeading_icon,
  borderRadius: '8px',
});
const CustomisedDeleteButton = styled(Button)({
  height: '5vh',
  padding: '0px 0.8em',
  borderRadius: '8px',
  backgroundColor: 'red',
  color: 'white',
  marginRight: '10px',
  fontSize: '0.7em',
  '&:hover': {
    backgroundColor: ColorsV2.acent,
  },
});
const CustomisedSettingsDeleteButton = styled(Button)({
  height: '42px',
  width: '30%',
  borderRadius: '8px',
  backgroundColor: 'red ',
  border: '1px solid red',
  color: 'white',
  fontSize: '14px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: ColorsV2.acent,
    border: ColorsV2.acent,
    color: 'white',
  },
});

// const CustomisedIconButton = styled(Button)({
//   height: '42px',
//   width: '30%',
//   borderRadius: '8px',
//   backgroundColor: 'red ',
//   border: '1px solid red',
//   color: 'white',
//   fontSize: '14px',
//   textTransform: 'none',
//   '&:hover': {
//     backgroundColor: ColorsV2.acent,
//     border: 'none',
//     color: 'white',
//   },
// });
const CustomisedSettingsLightModeDeleteButton = styled(Button)({
  height: '42px',
  width: '30%',
  borderRadius: '8px',
  backgroundColor: 'white ',
  border: '1px solid red',
  color: 'red',
  fontSize: '14px',
  textTransform: 'none',
  '&:hover': {
    border: `2px solid ${ColorsV2.acent}`,
  },
});
const CustomisedLightModeDeleteButton = styled(Button)({
  height: '39px',
  padding: '0px 20px',
  borderRadius: '8px',
  backgroundColor: 'white',
  border: '1px solid red',
  color: 'red',
  marginRight: '10px',
  fontSize: '14px',
  '&:hover': {
    border: `2px solid ${ColorsV2.acent}`,
  },
});
export {
  CustomisedButton,
  CustomisedIconButton,
  CustomisedSaveButton,
  CustomisedUploadButton,
  CustomisedDeleteButton,
  CustomisedSettingsDeleteButton,
  CustomisedSettingsLightModeDeleteButton,
  CustomisedLightModeDeleteButton,
  CustomisedLoadingIconButton,
};
